import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes
})



//////////////////
// WEBPACK FOOTER
// ./demo/router/index.js
// module id = 12
// module chunks = 0